export const getMyRequestAvatarBg = (status: number): string => {
    if (status === 0) return '#5B7A9F';
    if (status === 1) return '#4CAF50';
    return '#E57373';
};

export const getMyRequestChipSx = (status: number) => ({
    bgcolor: status === 0 ? '#E3F2FD' : status === 1 ? '#E8F5E9' : '#FFEBEE',
    color: status === 0 ? '#1565C0' : status === 1 ? '#2E7D32' : '#C62828',
    fontWeight: 600,
    fontSize: '0.75rem',
    height: 28,
    '& .MuiChip-icon': {
        color: 'inherit',
    },
});

export const getMyRequestNoteButtonSx = (hasNote: boolean) => ({
    color: hasNote ? '#667EEA' : '#94A3B8',
    bgcolor: hasNote ? '#F0F4FF' : '#F8FAFC',
    '&:hover': {
        bgcolor: hasNote ? '#E0E7FF' : '#F8FAFC',
        transform: hasNote ? 'scale(1.05)' : 'none',
    },
    '&.Mui-disabled': {
        color: '#CBD5E1',
        bgcolor: '#F1F5F9',
        cursor: 'not-allowed',
    },
    transition: 'all 0.2s ease',
});

export const getMyRequestDetailButtonSx = (status: number) => ({
    color: status === 2 ? '#ef5350' : '#4CAF50',
    bgcolor: status === 2 ? '#FFEBEE' : '#E8F5E9',
    '&:hover': {
        bgcolor: status === 2 ? '#FFCDD2' : '#C8E6C9',
        transform: 'scale(1.05)',
    },
    transition: 'all 0.2s ease',
});

export const formatMyRequestDate = (dateString: string) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    });
};
